import { ApplicationState } from 'clients/app/src/rootReducer';
import { useSelector } from 'react-redux';

import { QuizAnswer } from '~teacher/models/quizzes';

const useTrueFalseValue = ({
  answerIds,
  isEditing,
}: {
  answerIds: Array<string | number>;
  isEditing: boolean;
}): { value: boolean; trueAnswer: QuizAnswer; falseAnswer: QuizAnswer } =>
  useSelector((state: ApplicationState) => {
    const answers = answerIds.map((id) =>
      isEditing
        ? state.teachers.quizData.editAnswers[id]
        : state.teachers.quizData.answers[id]
    );
    const trueAnswer = answers.find((a) => a.text === 'True');
    const falseAnswer = answers.find((a) => a.text === 'False');
    const value =
      trueAnswer.isCorrect === true && falseAnswer.isCorrect === false
        ? true
        : false;
    return { value, trueAnswer, falseAnswer };
  });

export { useTrueFalseValue };
